import { Icon } from "@phosphor-icons/react";
import {
  ChatsTeardrop,
  GameController,
  Folders,
  GoogleLogo,
  Headset,
  SquaresFour,
  UsersThree,
  WhatsappLogo,
} from "@phosphor-icons/react";
import { isAdmin } from "../utils/helpers";

export type ComingSoonModalId = "whatsappCampaign" | "whatsappOrders" | "missedCalls" | "emailCampaign";

export type SubRoute = {
  path: string;
  pathName: string;
  hide?: (campaign: any) => boolean;
  hideAlways?: (campaign: any) => boolean;
  indent?: boolean; // Pour indenter les sous-items
  isSectionTitle?: boolean; // Pour les titres de section non cliquables
  comingSoonModal?: ComingSoonModalId;
};

export type NavRoute = {
  path: string;
  pathName: string;
  icon: Icon;
  hide?: (user: any) => boolean;
  subRoutes?: SubRoute[];
  hideChevron?: boolean;
  comingSoonModal?: ComingSoonModalId;
  isNew?: boolean;
  category?: string; // i18n key for the category label shown above the group
};

const routes: NavRoute[] = [
  {
    path: "/",
    pathName: "nav.home",
    icon: SquaresFour,
    hideChevron: true,
  },
  {
    path: "/fidelity",
    pathName: "nav.fidelity.title",
    icon: GameController,
    category: "nav.category.engagementClient",
    subRoutes: [
      {
        path: "/fidelity/performance",
        pathName: "nav.fidelity.performance",
      },
      {
        path: "/fidelity/sub-campaigns",
        pathName: "nav.fidelity.subCampaigns",
        hideAlways: (ctx) => !ctx?.campaign?.is_proxy,
      },
      {
        path: "",
        pathName: "nav.fidelity.configSection",
        isSectionTitle: true,
      },
      {
        path: "/fidelity/actions",
        pathName: "nav.fidelity.actions",
        indent: true,
      },
      {
        path: "/fidelity/customization",
        pathName: "nav.fidelity.customization",
        indent: true,
      },
      {
        path: "/fidelity/rewards",
        pathName: "nav.fidelity.rewards",
        indent: true,
      },
      // {
      //   path: "/fidelity/promo-codes",
      //   pathName: "nav.fidelity.promoCodes",
      //   indent: true,
      // },
      {
        path: "/fidelity/preview",
        pathName: "nav.fidelity.preview",
      },
      {
        path: "/fidelity/admin",
        pathName: "nav.fidelity.admin",
        hide: (user) => !isAdmin(user),
      },
      // {
      //   path: "/fidelity/distribution",
      //   pathName: "nav.fidelity.distribution",
      // },
    ],
  },
  {
    hide: (user) => !isAdmin(user),
    path: "/demo-campaigns",
    pathName: "nav.campaign.demo-campaigns",
    icon: Folders,
    category: "nav.category.engagementClient",
  },
  {
    path: "/google-performance",
    pathName: "nav.reviews.googlePerformance",
    icon: GoogleLogo,
    hideChevron: true,
    isNew: true,
    category: "nav.category.maFicheGoogle",
  },
  {
    path: "/reviews/management",
    pathName: "nav.reviews.title",
    icon: ChatsTeardrop,
  },
  {
    path: "/communications",
    pathName: "nav.communications.title",
    icon: Headset,
    category: "nav.category.communications",
    subRoutes: [
      // {
      //   path: "/communications/overview",
      //   pathName: "nav.communications.overview",
      // },
      {
        path: "/sms-campaigns",
        pathName: "nav.communications.sms",
      },
      {
        path: "/whatsapp-campaign",
        pathName: "nav.communications.whatsapp",
        comingSoonModal: "whatsappCampaign" as const,
      },
      {
        path: "/email-campaign",
        pathName: "nav.communications.email",
        comingSoonModal: "emailCampaign" as const,
      },
      {
        path: "/communications/missed-calls",
        pathName: "nav.communications.missedCalls",
        comingSoonModal: "missedCalls" as const,
      },
    ],
  },
  {
    // TODO: decide when to hide it
    path: "/orders",
    pathName: "nav.orders.title",
    icon: WhatsappLogo,
    comingSoonModal: "whatsappOrders" as const,
    category: "nav.category.communications",
    subRoutes: [
      {
        path: "/orders",
        pathName: "nav.orders.overview",
      },
      {
        path: "/orders/configs",
        pathName: "nav.orders.configuration",
      },
      {
        path: "/orders/chat",
        pathName: "nav.orders.chat",
      },
    ],
  },
  {
    path: "/users",
    pathName: "nav.users",
    icon: UsersThree,
  },
  {
    hide: (user) => !isAdmin(user),
    path: "/admin-players",
    pathName: "nav.adminPlayers",
    icon: UsersThree,
  },
];

export default routes;
